// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const phione: PokeData = {
  "id": 489,
  "name": "phione",
  "height": 4,
  "weight": 31,
  "base_experience": 216,
  "types": [
    PokeType.WATER
  ],
  "api_moves": [
    "supersonic",
    "water-gun",
    "hydro-pump",
    "bubble-beam",
    "confusion",
    "bubble",
    "acid-armor",
    "charm",
    "rain-dance",
    "whirlpool",
    "dive",
    "water-sport",
    "water-pulse",
    "aqua-ring",
    "zen-headbutt",
    "moonblast",
    "take-heart"
  ],
  "moves": [
    "supersonic",
    "hydro-pump",
    "bubble-beam",
    "bubble",
    "rain-dance",
    "whirlpool",
    "zen-headbutt",
    "moonblast",
    "brine",
    "life-dew",
    "liquidation",
    "aqua-jet",
    "aqua-tail"
  ],
  "evolution_chain": {
    "id": 250,
    "item": null,
    "species": [
      {
        "name": "phione",
        "order": 490,
        "types": [
          PokeType.WATER
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "manaphy",
        "order": 491,
        "types": [
          PokeType.WATER
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 133,
    "speed": 133,
    "ability_power": 133
  },
  "stat_changes": [],
  "catch_rate": 30,
  "is_legendary": false,
  "is_mythical": true,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
